<template>
  <div :style="getBackground()">
    <div class="home-page-container main">
      <div class="home-page-locale">
        <ul class="nav float-right account-btns">
          <li class="dropdown">
            <a
              id="navbarDropdown"
              class="dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span>
                <i class="fa fa-1-5x fa-globe"></i>
              </span>
            </a>
            <div
              class="dropdown-menu lg-dropdown-menu home-page-dropdown-menu"
              aria-labelledby="navbarDropdown"
            >
              <a
                v-for="(lang, index) in getAvailableLanguages"
                :key="index"
                href="javascript:void(0)"
                class="dropdown-item pl-0"
                @click="setLocale(lang.locale)"
                >{{ lang.name }}</a
              >
            </div>
          </li>
        </ul>
      </div>
      <div class="home-page-logo">
        <img :src="this.currentStoreDoc.Logo" />
      </div>
      <label class="welcome-section">{{ $t("message.welcomeTo") }}</label>
      <h3>{{ currentStoreDoc.Name }}</h3>
      <div v-if="item.Table && !showTableInput" class="home-page-table-number">
        <label>{{ $t("message.tableNumber") }}</label>
        <h3>{{ item.Table }}</h3>
      </div>
      <h3 class="geust-check-in-title">{{ $t("message.guestCheckIn") }}</h3>
      <form @submit.prevent="checkIn()">
        <div class="check-in-form">
          <div class="form-group">
            <label for="name">{{ $t("message.name") }}</label>
            <input
              v-validate="'required|min:2'"
              id="name"
              v-model="item.Name"
              name="name"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("name") | inputNameLocale("name") }}
            </div>
          </div>
          <div class="form-group">
            <label for="phoneNumber">{{ $t("message.mobile") }}</label>
            <input
              v-validate="'required|min:2'"
              id="phoneNumber"
              v-model="item.Phone"
              name="phoneNumber"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{
                OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber")
              }}
            </div>
          </div>
          <div class="form-group">
            <label for="emailAddress">{{ $t("message.emailAddress") }}</label>
            <input
              v-validate="{ required: isEmailRequired, email: true }"
              id="emailAddress"
              v-model="item.Email"
              name="emailAddress"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{
                OOErrors.first("emailAddress") | inputNameLocale("emailAddress")
              }}
            </div>
          </div>
          <div v-if="showTableInput" class="form-group">
            <label for="tableNumber">{{ $t("message.tableNumber") }}</label>
            <input
              id="tableNumber"
              v-model="item.Table"
              name="tableNumber"
              type="text"
              class="form-control"
            />
          </div>
          <div
            v-if="!getIsHideCheckboxMarketing"
            class="form-group terms-condition"
          >
            <label class="checkbox-label">
              <input
                ref="agreeInput"
                type="checkbox"
                :checked="item.AgreeToReceivePromotionalOffers"
                v-model="item.AgreeToReceivePromotionalOffers"
              />
              <span class="checkbox-checkmark" :style="getStyle()"></span>
            </label>
            <p>
              I am interested to be the first to know of any specials or deals
              offered by {{ currentStoreDoc.Name }}
            </p>
          </div>
          <button
            class="btn btn-primary btn-lg btn-block shadow mb-2 d-flex justify-content-center align-items-center"
            :style="mobileStyles.btn"
            :disabled="proccessing"
            type="submit"
          >
            Check-in
            <span v-show="proccessing">
              <i class="spin ml-4" />
            </span>
          </button>
          <div class="text-red" v-show="errorMessage">{{ errorMessage }}</div>
        </div>
      </form>
      <div>
        <poweredby />
      </div>
    </div>
  </div>
</template>

<script>
import poweredby from "../shared/poweredby.vue";
import { mapGetters, mapMutations } from "vuex";
import { Validator } from "vee-validate";
import en from "vee-validate/dist/locale/en";
import zh_CN from "vee-validate/dist/locale/zh_CN";
import { RegisterVisit, UpdateCustomer } from "../../api/services/userService";
import uuid from "uuid/v1";
export default {
  components: {
    poweredby,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      item: { AgreeToReceivePromotionalOffers: false },
      showTableInput: false,
      proccessing: false,
      errorMessage: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let table = to.query.table || localStorage.getItem("table");
      if (table) {
        vm.$data.item.Table = table;
        vm.$data.showTableInput = table == 0;
      }
    });
  },
  mounted() {
    if (localStorage.getItem("guestCheckinUser"))
      this.item = JSON.parse(localStorage.getItem("guestCheckinUser"));
  },
  computed: {
    ...mapGetters([
      "storeMenu",
      "getloadedMenu",
      "currentStoreDoc",
      "getAvailableLanguages",
      "mobileStyles",
      "getAllStoreMenus",
      "viewConfig",
    ]),
    isEmailRequired() {
      return this.item.AgreeToReceivePromotionalOffers === true;
    },
    getIsHideCheckboxMarketing() {
      return this.viewConfig.IsHideCheckboxMarketing;
    },
  },
  methods: {
    ...mapMutations(["setCurrentLocale"]),
    getBackground() {
      var style = [
        { "background-image": `url(${this.currentStoreDoc.ProfileImage})` },
        { height: "auto" },
        { "min-height": "100vh" },
        { "background-repeat": "no-repeat" },
        { "background-size": "cover" },
      ];
      return style;
    },
    getStyle() {
      var style = [];
      if (this.value) {
        style.push(this.mobileStyles.CommonColorBackground);
      } else {
        style.push(this.mobileStyles.pendingStatusBackground);
      }
      return style;
    },
    getLogo() {
      var style = [
        { "background-image": `url(${this.currentStoreDoc.Logo})` },
        { "background-repeat": "no-repeat" },
        { "background-size": "contain" },
      ];
      return style;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      Validator.localize(locale, locale == "en" ? en : zh_CN);
      this.setCurrentLocale(locale);
    },
    checkIn() {
      this.$validator.validateAll().then(async (valid) => {
        if (valid) {
          localStorage.setItem("guestCheckinUser", JSON.stringify(this.item));
          this.proccessing = true;
          var udid = uuid();
          this.item.HQCompanyID = this.currentStoreDoc.ID;
          RegisterVisit(udid, this.item).then(
            (response) => {
              if (response.data.Success) {
                if (
                  this.item.Email &&
                  this.item.AgreeToReceivePromotionalOffers
                ) {
                  UpdateCustomer(udid, {
                    FirstName: this.item.Name.split(" ")[0],
                    LastName: this.item.Name.split(" ")[1] || "",
                    Email: this.item.Email,
                    HQCompanyID: this.currentStoreDoc.HQCompanyID,
                    Mobile: this.item.Phone,
                  }).then(() => {});

                  this.$router.push({
                    name: "store",
                    params: {
                      storeid: this.storeid,
                      storename: this.$route.params.storename,
                      message: this.$t("message.visitRegisterSuccess"),
                      fromCheckin: true,
                    },
                    query: { table: this.item.Table },
                  });
                } else {
                  this.$router.push({
                    name: "store",
                    params: {
                      storeid: this.storeid,
                      storename: this.$route.params.storename,
                      message: this.$t("message.visitRegisterSuccess"),
                      fromCheckin: true,
                    },
                    query: { table: this.item.Table },
                  });
                }
              } else {
                this.proccessing = false;
                this.errorMessage = this.$t("message.visitRegisterError");
              }
            },
            () => {
              this.proccessing = false;
              this.errorMessage = this.$t("message.visitRegisterError");
            }
          );
        }
      });
    },
  },
};
</script>
